import { render, staticRenderFns } from "./field-admin-view.html?vue&type=template&id=f94683c0&scoped=true&external"
import script from "./field-admin-view.js?vue&type=script&lang=js&external"
export * from "./field-admin-view.js?vue&type=script&lang=js&external"
import style0 from "./field-admin-view.scss?vue&type=style&index=0&id=f94683c0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94683c0",
  null
  
)

export default component.exports